import contimg2 from "../../assets/contimg2.jpg";
import contimg3 from "../../assets/contimg3.jpg";

export const officeLocations = [
  {
    img: <img src={contimg2} alt="slide" />,
    location: " Atlanta, USA",
    address: "3340 Peachtree Road NE Ste 1010",
    postal: " Atlanta, GA 30326",
    tel: "Tel: +1 470 242-1783",
  },
  {
    img: <img src={contimg3} alt="slide" />,
    location: "Los Angeles, USA",
    address: "750 N San Vicente Blvd Ste 800 W.",
    postal: " West Hollywood, CA 90069",
    tel: "Tel: +1 310 496-9395",
  },
];

export const faqs = [
  {
    ques: "How do I request for a service?",
    ans: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae accumsan urna eros, fermentum pellentesque. Faucibus sit ut tincidunt eros nec vitae sit donec sit. Quis turpis sagittis consectetur ultricies est arcu laoreet. Molestie lectus scelerisque sit turpis enim quam duis. Volutpat at malesuada lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
  {
    ques: "How do I request for a service?",
    ans: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae accumsan urna eros, fermentum pellentesque. Faucibus sit ut tincidunt eros nec vitae sit donec sit. Quis turpis sagittis consectetur ultricies est arcu laoreet. Molestie lectus scelerisque sit turpis enim quam duis. Volutpat at malesuada lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
  {
    ques: "How do I request for a service?",
    ans: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae accumsan urna eros, fermentum pellentesque. Faucibus sit ut tincidunt eros nec vitae sit donec sit. Quis turpis sagittis consectetur ultricies est arcu laoreet. Molestie lectus scelerisque sit turpis enim quam duis. Volutpat at malesuada lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
  {
    ques: "How do I request for a service?",
    ans: "lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
  {
    ques: "How do I request for a service?",
    ans: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae accumsan urna eros, fermentum pellentesque. Faucibus sit ut tincidunt eros nec vitae sit donec sit. Quis turpis sagittis consectetur ultricies est arcu laoreet. Molestie lectus scelerisque sit turpis enim quam duis. Volutpat at malesuada lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
  {
    ques: "How do I request for a service?",
    ans: " Lorem ipsum dolor sit amet, consectetur adipiscing elit. .",
  },
  {
    ques: "How do I request for a service?",
    ans: "  Vitae accumsan urna eros, fermentum pellentesque. eros nec vitae sit donec sit. Quis turpis sagittis consectetur ultricies est arcu laoreet. Molestie lectus scelerisque sit turpis enim quam duis. Volutpat at malesuada lectus vel risus tincidunt sodales amet, morbi. Est rutrum lorem placerat iaculis proin.",
  },
];
